export default "__VITE_ASSET__BTi$BjTo__"